import React, {useMemo} from 'react'
import {
    GoogleMap,
    useLoadScript,
    Marker
  } from "@react-google-maps/api"
//import '../Styles/GoogleMaps.css'

const mapContainerStyle = {
    width: "26rem",
    height: "25rem",

  };

const center = {
    lat: -12.12552459365246,
    lng:  -76.99985793148731

  }

function Map() {


  const markerTest = useMemo(() => (
    { 
      lat: -12.126115773425676, 
      lng:  -77.00026844537197
    
    }), []); 
  
    
    const {isLoaded, loadError} = useLoadScript({
      googleMapsApiKey: process.env.REACT_APP_MY_API_KEY,
    });
  
    if (loadError) return "Error loading maps";
    if (!isLoaded) return "Loading "

   

  return (
      <GoogleMap 
        mapContainerStyle={mapContainerStyle} 
        zoom={17}
        center={center}
      >
        <Marker
          title={'Mila Detalles para el Hogar '}
          name={'MILA'}   
          key={2} 
          position={markerTest} 
        />
      </GoogleMap>
  )
}

export default Map